function paintProgressBars() {
  document.querySelectorAll(".progress").forEach((bar) => {
    const span = bar.querySelector("span");
    if (!span) return;
    const max = Number(bar.getAttribute("aria-valuemax"));
    const now = Number(bar.getAttribute("aria-valuenow"));
    if (!Number.isFinite(max) || max <= 0 || !Number.isFinite(now)) return;
    const width = Math.max(0, Math.min(100, (now / max) * 100));
    span.style.width = `${width}%`;
  });
}

paintProgressBars();
